import { connect } from 'react-redux';
import { PureComponent, Fragment } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';

import { AppState } from '../../../store';
import { currentVendorIdSelector } from '../../../vendors/services/currentVendorSelector';
import { DuckFunction } from 'src/contracts/ducks';
import { isBulkyItemSchedulerFeatureEnabled } from 'src/vendors/ducks/features';
import { loadBulkyItemScheduler } from 'src/vendors/ducks';
import { loadBulkyPickUpByLocation } from 'src/customers/ducks/locations';
import { loadLocationAlerts, loadCustomer, loadCustomerLocations } from '../../ducks';
import { PageLoadingOverlay } from '../../../common/components/styled';
import { Resolver } from '../../../core/components';
import CustomerLocationsEditorModal from './CustomerLocationsEditorModal';

const vendorIdSelector = currentVendorIdSelector as any;

interface Props extends RouteComponentProps {
  customerId?: number;
  isBulkyItemSchedulerEnabled: boolean;
  loadBulkyItemScheduler: DuckFunction<typeof loadBulkyItemScheduler>;
  loadBulkyPickUpByLocation: DuckFunction<typeof loadBulkyPickUpByLocation>;
  loadCustomer: DuckFunction<typeof loadCustomer>;
  loadCustomerLocations: DuckFunction<typeof loadCustomerLocations>;
  loadLocationAlerts: any;
  locationId?: number;
  newCustomerId?: number;
  onCancel: any;
  onSaveLocation?: any;
  serviceContractFullAddress?: any;
  serviceContractLocation?: string;
  vendorId?: number;
}

class CustomerLocationsEditorModalResolver extends PureComponent<Props> {
  loadDependencies = () => {
    const {
      customerId,
      isBulkyItemSchedulerEnabled,
      loadBulkyItemScheduler,
      loadBulkyPickUpByLocation,
      loadCustomer,
      loadCustomerLocations,
      loadLocationAlerts,
      locationId,
      vendorId,
    } = this.props;

    const dependencies: Promise<unknown>[] = [loadLocationAlerts(vendorId)];

    if (customerId) {
      dependencies.push(loadCustomer(customerId), loadCustomerLocations(customerId));
    }

    if (vendorId && locationId && isBulkyItemSchedulerEnabled) {
      dependencies.push(loadBulkyItemScheduler(vendorId), loadBulkyPickUpByLocation(locationId));
    }

    return Promise.all(dependencies);
  };

  render() {
    const {
      onCancel,
      onSaveLocation,
      locationId,
      customerId,
      newCustomerId,
      serviceContractLocation,
      serviceContractFullAddress,
    } = this.props;

    return (
      <Fragment>
        <Resolver
          successComponent={CustomerLocationsEditorModal}
          loadingComponent={PageLoadingOverlay}
          successProps={{
            onCancel,
            onSaveLocation,
            locationId,
            newCustomerId: newCustomerId || customerId,
            serviceContractLocation,
            serviceContractFullAddress,
          }}
          resolve={this.loadDependencies}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  isBulkyItemSchedulerEnabled: isBulkyItemSchedulerFeatureEnabled(state),
  vendorId: vendorIdSelector(state.account.login, state.vendors.defaultVendor),
});

const mapDispatchToProps = {
  loadBulkyItemScheduler,
  loadBulkyPickUpByLocation,
  loadCustomer,
  loadCustomerLocations,
  loadLocationAlerts,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerLocationsEditorModalResolver));
